export const TIPO_FICHERO = {
  IMAGEN: 0,
  PDF: 1,
  LOGO: 2,
  TEXTO: 3,
  EXCEL: 4,
  DOC: 5,
  CSV: 6,
  EDI: 7,
  XLM: 8,
  DESCONOCIDO: -1,
} as const

export type TipoFicheroType = (typeof TIPO_FICHERO)[keyof typeof TIPO_FICHERO]
